module.exports = __webpack_public_path__ + "static/media/Rounds-04.22a35566.png";